import { BrevityTween } from '@tencent/brevity';
import { IStyle, IAnimation, IParams } from './interface';

export default class Animation implements IAnimation {
    public static set = (target, params): void => {
        BrevityTween.set(target, { ...params, duration: 0 });
    };
    public instance;
    public vars;

    public constructor({ type, target, fromStyle, toStyle }: IParams) {
        this.instance = this.getInstance({ type, target, fromStyle, toStyle });
        this.vars = this.instance?.vars;
    }

    /**
     * 开始播放
     */
    public play(): void {
        this.instance?.play();
    }

    /**
     * 从头开始播放
     */
    public restart(): void {
        this.instance?.restart();
    }
    // 暂停播放
    public pause(): void {
        this.instance?.pause();
    }

    /**
     * 从暂停处恢复播放
     */
    public resume(): void {
        this.instance?.resume();
    }

    /**
     * 动画是否在运行
     * @returns Boolean
     */
    public isActive(): boolean {
        return this.instance?.isActive();
    }

    /**
     * 给动画的目标元素设置样式
     * @param style
     */
    public set(style: IStyle): void {
        const target = this.instance?.target();
        BrevityTween.set(target, style);
    }

    private getInstance({ type, target, fromStyle, toStyle }) {
        switch (type) {
            case 'fromTo':
                return BrevityTween.fromTo(target, fromStyle, toStyle);
            default:
                return null;
        }
    }
}
